/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React, {memo, useEffect, useRef, useState} from 'react';

import {isEqual} from 'lodash';
import {useSelector, useDispatch} from 'react-redux';

import * as loadingActions from '@/actions/loadingActions';
import * as manualControlActions from '@/actions/manualControlActions';
import * as modalActions from '@/actions/modalActions';
import {showPopUp} from '@/actions/modalActions';
import axiosMethods from '@/api/apiManager';
import PopUpWizard from '@/components/popup/PopUpWizard';
import {AutoProfileConstants} from '@/constants/autoProfileEnum';
import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';
import {ManualControlEventTopMenu} from '@/constants/pubSubEnum';
import {MANUAL_CONTROL, MIXING_CYCLE} from '@/constants/statusManualControlEnum';
import {newLineHtml} from '@/libs/htmlHelper';
import {eventBusObject} from '@/observers/eventBus';

import {
  DataHelpHome,
  DataHelpConcentrate,
  DataHelpConcentrateMoreThan50,
  DataHelpBufferDiscrete,
  DataHelpBufferContinuous,
  DataHelpAdvancedSetup,
  DataHelpManualControl,
  DataHelpStatusAndGraph,
  DataHelpRecovery,
} from '../help/AutoProfileHelp';

import '../status/AutoProfileStatus.less';

// TODO should differentiate the component name with .\PC.Client\ClientApp\Components\views\status\reusable\StatusProfile.js

function StatusProfile(props) {
  const dispatch = useDispatch();
  const {
    profileConfigFinalVolume,
    currentPCState,
    isPCRunning,
    isPCPaused,
    lockAccess,
    manualControlThreshold,
    modeHelp,
    profileId,
    autoRecovery,
  } = useSelector((store) => {
    const {profileRunning, currentPCState, isPCRunning, isPCPaused, lockAccess, currentAdvSetupParams, modeHelp} =
      store.setupStore;
    return {
      profileConfigFinalVolume: profileRunning?.Config?.FinalVolume,
      profileId: profileRunning?.Id,
      currentPCState,
      isPCRunning,
      isPCPaused,
      lockAccess,
      manualControlThreshold: currentAdvSetupParams?.ConfigAdvSetup?.GeneralAdvSetup?.ManualControlThreshold,
      modeHelp,
      autoRecovery: currentAdvSetupParams?.ConfigAdvSetup?.GeneralAdvSetup?.AutoRecoveryFlag,
    };
  }, isEqual);
  const {manualControlStatus, RequestPendingManualControl} = useSelector(
    (store) => ({
      manualControlStatus: store.manualControlStore.StatusManualControl,
      RequestPendingManualControl: store.manualControlStore.RequestPendingManualControl,
    }),
    isEqual,
  );

  const _bus = eventBusObject();
  const _statusUpdater = useRef();
  const _IsLastRunnigProfileRecorded = useRef(false);

  // const [, setLastRunningProfile] = useState(initialState.profileRunning);
  const [manualControlLabel, setManualControlLabel] = useState('MANUAL CONTROL');
  const [isDisableManualControlButton, setIsDisableManualControlButton] = useState(false);
  const [, setManualControlThreshold] = useState(0);
  const [contentHelp, setContentHelp] = useState(DataHelpHome);
  const [isHelpModeEnable, setIsHelpModeEnable] = useState(false);

  useEffect(() => {
    let content;
    switch (modeHelp) {
      case APPDATA.HOME_HELP:
        content = DataHelpHome;
        break;
      case APPDATA.CONCENTRATE_HELP:
        content = DataHelpConcentrate;
        break;
      case APPDATA.CONCENTRATE50ML_HELP:
        content = DataHelpConcentrateMoreThan50;
        break;
      case APPDATA.BUFFER_DISCRETE_HELP:
        content = DataHelpBufferDiscrete;
        break;
      case APPDATA.BUFFER_CONTINOUS_HELP:
        content = DataHelpBufferContinuous;
        break;
      case APPDATA.ADVANCED_SETUP_HELP:
        content = DataHelpAdvancedSetup;
        break;
      case APPDATA.MANUAL_CONTROL_HELP:
        content = DataHelpManualControl;
        break;
      case APPDATA.STATUS_GRAPH_HELP:
        content = DataHelpStatusAndGraph;
        break;
      case APPDATA.RECOVERY_HELP:
        content = DataHelpRecovery;
        break;
      default:
        content = DataHelpHome;
        break;
    }
    setContentHelp(content);
  }, [modeHelp]);

  useEffect(() => {
    if (props.isManualControlEnable) {
      setManualControlLabel(MANUAL_CONTROL);
    }
    _statusUpdater.current = setInterval(() => {
      const IsProfileRunning = profileId !== -1;
      if (IsProfileRunning === false) {
        if (_IsLastRunnigProfileRecorded.current === true) {
          _IsLastRunnigProfileRecorded.current = false;
        }
      } else if (_IsLastRunnigProfileRecorded.current === false) {
        // setLastRunningProfile(props.profileRunning);
        _IsLastRunnigProfileRecorded.current = true;
      }
    }, APPDATA.CONFIGURATION.INTERVAL.STATUS_TIME_UPDATE);
    return () => {
      clearInterval(_statusUpdater.current);
      _statusUpdater.current = null;
    };
  }, [profileId, props.isManualControlEnable]);

  useEffect(() => {
    setManualControlThreshold(parseFloat(manualControlThreshold));
  }, [manualControlThreshold]);

  useEffect(() => {
    let isDisableManualControlButtons = true;
    if (lockAccess) isDisableManualControlButtons = true;
    else if (isPCRunning === false || isPCPaused === true || currentPCState !== APPDATA.PC_CONCENTRATING_STATE)
      isDisableManualControlButtons = true;
    else if (manualControlStatus.IsLastConcentration === 'true') {
      if (manualControlStatus.IsManualControlEnable === 'true') {
        // disable button when manual control is active
        isDisableManualControlButtons = true;
      } else if (RequestPendingManualControl) isDisableManualControlButtons = true;
      else isDisableManualControlButtons = false;
    } else {
      isDisableManualControlButtons = true;
    }

    setIsDisableManualControlButton(isDisableManualControlButtons);
  }, [
    lockAccess,
    isPCRunning,
    isPCPaused,
    currentPCState,
    manualControlStatus.IsLastConcentration,
    manualControlStatus.IsManualControlEnable,
    RequestPendingManualControl,
  ]);

  const manualControlPopUpAction = (e) => {
    switch (e.currentTarget.id) {
      case APPDATA.CONFIRM:
        setManualControlLabel(MANUAL_CONTROL);
        dispatch(manualControlActions.IsShowManualControlAvailablePopUp(true));
        dispatch(manualControlActions.IsShowManualControlPopUp(true));
        _bus.publish(ManualControlEventTopMenu.EnableManualControlTopMenu, '');
        dispatch(
          loadingActions.updateLoading({
            showLoading: true,
            loadingText: APPDATA.MESSAGES.CYCLE_PROCESS.SWITCH_TO_MANUAL_CONTROL,
            loadingClickEvent: undefined,
          }),
        );
        showManualControlPopup();
        break;
      case APPDATA.CANCEL:
        break;
      case APPDATA.HELP:
        setIsHelpModeEnable(true);
        break;
      default:
        break;
    }
    dispatch(modalActions.hidePopUp());
  };

  const showManualControlPopup = () => {
    const manualControlButton = [
      {
        id: APPDATA.PROCEED_TO_RECOVERY,
        isPrimaryButton: true,
        onClick: manualControlPopUpAction,
        label: APPDATA.PROCEED_TO_RECOVERY,
      },
    ];

    dispatch(
      showPopUp({
        popUpTitle: 'Manual Control',
        popUpText: (
          <div className="center">
            {/* <span className="popUpTextCenter"> */}
            <span>{newLineHtml(APPDATA.MESSAGES.MANUAL_CONTROL.POP_UP_BUTTON_SWITCH_MANUAL_CONTROL)}</span>
          </div>
        ),
        popUpButton: manualControlButton,
        popUpHideCloseButton: true,
      }),
    );
  };

  const onClick = (e) => {
    switch (e.currentTarget.id) {
      case MANUAL_CONTROL: {
        const manualControlButton = [
          {
            id: APPDATA.HELP,
            isPrimaryButton: false,
            onClick: manualControlPopUpAction,
            label: APPDATA.HELP,
            className: 'tertiaryButton',
          },
          {
            id: APPDATA.CANCEL,
            isPrimaryButton: false,
            onClick: manualControlPopUpAction,
            label: APPDATA.CANCEL,
          },
          {
            id: APPDATA.CONFIRM,
            isPrimaryButton: true,
            onClick: manualControlPopUpAction,
            label: APPDATA.CONFIRM,
          },
        ];

        dispatch(
          showPopUp({
            popUpTitle: 'Manual Control',
            popUpText: (
              <div className="center">
                {/* <span className="popUpTextCenter"> */}
                <span>{newLineHtml(APPDATA.MESSAGES.MANUAL_CONTROL.POP_UP_BUTTON_SWITCH_MANUAL_CONTROL)}</span>
              </div>
            ),
            popUpButton: manualControlButton,
            popUpHideCloseButton: true,
          }),
        );
        break;
      }
      default:
        break;
    }
  };

  const performMixingCycle = () => {
    axiosMethods
      .post(APPDATA.API.START_MIXING)
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const onCloseHelpWizard = () => {
    setIsHelpModeEnable(false);
  };

  return (
    <>
      <div className={`${APPSTYLE.COLUMN_FULL}profileControlBox no-padding`}>
        {!autoRecovery && profileConfigFinalVolume < AutoProfileConstants.FINAL_VOLUME_POP_UP_VALUE_THREE && (
          <button
            type="button"
            id={MANUAL_CONTROL}
            className="manual-control"
            onClick={onClick}
            disabled={isDisableManualControlButton}
          >
            {manualControlLabel}
          </button>
        )}
        <button
          type="button"
          id={MIXING_CYCLE}
          className="manual-control outlined-btn"
          onClick={performMixingCycle}
          disabled={currentPCState !== APPDATA.DEVICE_STATE.CONCENTRATING}
        >
          {MIXING_CYCLE}
        </button>
      </div>
      <PopUpWizard
        data={contentHelp}
        fontSize={props.fontSize}
        popUpWizardVisible={isHelpModeEnable}
        onClose={onCloseHelpWizard}
      />
    </>
  );
}
export default memo(StatusProfile);
